// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ingredient-row{display:flex;flex-wrap:wrap;justify-content:center}.ingredient-row__ingredient{flex:0 1 auto;margin-bottom:var(--y-gutter-sm);padding-left:1.25em;padding-right:1.25em;text-align:center;width:100%}@media (min-width:480px){.ingredient-row__ingredient{width:50%}}@media (min-width:1024px){.ingredient-row__ingredient{width:25%}}@media (min-width:1200px){.ingredient-row__ingredient{padding-left:1.75em;padding-right:1.75em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
